export const curl = state => {
    return state.curl
}



// WEBPACK FOOTER //
// ./src/store/modules/curl/getters.js